<template>
    <div>
      <div class="macc-main " style="border: none; height: 100%;width: 100%">
         <!--沙盘页面-->
          <iframe :src="sandUrl" frameborder="0" v-if="sandUrl" style="height: 100%;width: 100%"
            allowfullscreen="true"></iframe>
        </div>
    </div>
</template>
<script>

export default {
  name: 'MockMacc',
  components: {
  },
  data() {
    return {
      sandUrl: ''
    }
  },
  created() {
    console.log(this.data)
    this.sandUrl = this.data.classesUrls.length > 0 ? this.data.classesUrls[0].url : ''
  },
  props: {
    data: {
      type: Object,
      required: false,
      default: null
    },
  },
  methods: {
  },
}
</script>
<style scoped lang="less">

</style>
